import { z } from 'zod';
import { SearchSchema } from '@anytag/shared-validations';

export enum TableModeType {
  VIEW = 'VIEW',
  EDIT = 'EDIT'
}

export const EngagementProposalSearchSchema = SearchSchema.create({
  filter: {
    schema: z.object({ tableViewMode: SearchSchema.types.enum(TableModeType) }),
    defaultValues: { tableViewMode: TableModeType.VIEW }
  }
});

export type EngagementProposalSearchSchemaType = z.infer<typeof EngagementProposalSearchSchema>;
